import { FILTROS_DA_FILA, type FiltroDaFila, type Gravidade, type OrdemDaFila } from "./api"

export type EstadoDoPainel = {
  filtro?: FiltroDaFila
  faixa?: string
  ordem?: OrdemDaFila
  gravidade?: Gravidade
  pagina?: number
}

const ORDENS: readonly OrdemDaFila[] = ["contrato", "-contrato"]
const FAIXA = /^[a-z0-9_]{1,30}$/
const GRAVIDADES: readonly Gravidade[] = ["critico", "atencao", "informacao"]

export function estadoLimpo(estado: EstadoDoPainel): EstadoDoPainel {
  const limpo: EstadoDoPainel = {}
  if (estado.filtro !== undefined && estado.filtro !== "todos" && FILTROS_DA_FILA.includes(estado.filtro)) {
    limpo.filtro = estado.filtro
  }
  if (estado.faixa !== undefined && FAIXA.test(estado.faixa)) limpo.faixa = estado.faixa
  if (estado.ordem !== undefined && ORDENS.includes(estado.ordem)) limpo.ordem = estado.ordem
  if (estado.gravidade !== undefined && GRAVIDADES.includes(estado.gravidade)) limpo.gravidade = estado.gravidade
  if (estado.pagina !== undefined && Number.isInteger(estado.pagina) && estado.pagina > 1) limpo.pagina = estado.pagina
  return limpo
}

export function buscaDoPainel(estado: EstadoDoPainel): string {
  const limpo = estadoLimpo(estado)
  const parametros = new URLSearchParams()
  if (limpo.filtro !== undefined) parametros.set("filtro", limpo.filtro)
  if (limpo.faixa !== undefined) parametros.set("faixa", limpo.faixa)
  if (limpo.ordem !== undefined) parametros.set("ordem", limpo.ordem)
  if (limpo.gravidade !== undefined) parametros.set("gravidade", limpo.gravidade)
  if (limpo.pagina !== undefined) parametros.set("pagina", String(limpo.pagina))
  return parametros.toString()
}

export function estadoDaBusca(busca: string): EstadoDoPainel {
  const parametros = new URLSearchParams(busca)
  const pagina = Number(parametros.get("pagina"))
  return estadoLimpo({
    filtro: (parametros.get("filtro") ?? undefined) as FiltroDaFila | undefined,
    faixa: parametros.get("faixa") ?? undefined,
    ordem: (parametros.get("ordem") ?? undefined) as OrdemDaFila | undefined,
    gravidade: (parametros.get("gravidade") ?? undefined) as Gravidade | undefined,
    pagina: parametros.has("pagina") ? pagina : undefined,
  })
}
